import OrderHistoryContainer from "../../../components/applications/eCommerce/orderHistory";

const OrderHistory = () => {
  return <OrderHistoryContainer />;
};

export default OrderHistory;
